import React, { useState } from "react";
import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTractor, faUsers, faShoppingCart, faWarehouse,
  faTruck, faHandHoldingUsd, faSeedling, faCow,
  faEgg, faFish
} from "@fortawesome/free-solid-svg-icons";
import MSMEMetaverseStakeholderModal from "./MSMEMetaverseStakeholderModal";

const stakeholders = [
  { icon: faTractor, label: "Farmers", info: "Upload crops, check prices." },
  { icon: faUsers, label: "Families", info: "Support, education & well-being." },
  { icon: faShoppingCart, label: "Buyers", info: "Browse available produce." },
  { icon: faWarehouse, label: "Warehouse", info: "Storage and cold chains." },
  { icon: faTruck, label: "Logistics", info: "Transport produce to markets." },
  { icon: faHandHoldingUsd, label: "Banks", info: "Credit & insurance services." },
  { icon: faSeedling, label: "Nursery", info: "Seeds & saplings for farms." },
  { icon: faCow, label: "Dairy", info: "Milk and dairy management." },
  { icon: faEgg, label: "Poultry", info: "Eggs and chicken produce." },
  { icon: faFish, label: "Fisheries", info: "Fish farming & aqua trade." },
];

const MSMEMetaverseStakeholdersGrid = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div>
      <motion.div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 w-full max-w-5xl mx-auto"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 1 }}
      >
        {stakeholders.map((s, i) => (
          <motion.div
            key={i}
            className="bg-white p-4 rounded-2xl shadow-md flex flex-col items-center cursor-pointer hover:shadow-xl"
            whileHover={{ scale: 1.05 }}
            onClick={() => setSelected(s)}
          >
            <FontAwesomeIcon icon={s.icon} className="text-green-700 text-3xl mb-2" />
            <span className="font-medium text-green-900">{s.label}</span>
          </motion.div>
        ))}
      </motion.div>

      {selected && (
        <MSMEMetaverseStakeholderModal stakeholder={selected} onClose={() => setSelected(null)} />
      )}
    </div>
  );
};

export default MSMEMetaverseStakeholdersGrid;
